import { useQuery } from '@tanstack/react-query';
import { SB_HOST_QUERY_KEY } from '@kc-console/guard';

const defaultLnbCollapsed = false;

const fetchDefaultLnbCollapsed = (): Promise<boolean> => Promise.resolve(defaultLnbCollapsed);

/**
 * LNB 접힘/펼침 상태
 */
export const useLnbCollapsedQuery = () => {
  return useQuery({
    queryKey: [SB_HOST_QUERY_KEY.GET_LNB_COLLAPSED],
    queryFn: fetchDefaultLnbCollapsed,
    staleTime: Infinity,
    gcTime: Infinity,
  });
};
